import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import store from '../store/index'
import VueCookies from 'vue-cookies'
Vue.use(VueRouter)
Vue.prototype.axios = axios
Vue.prototype.VueAxios = VueAxios
Vue.use(store,VueCookies)

const routes = [{
    path: '/',
    component: () => import('../views/login.vue')
  },
  {
    path: '/shop',
    component: () => import('../components/bioshopall'),
    beforeEnter: (to, from, next) => {
      axios.get(store.state.serve + "shop/is_login", {
        params: {
          token: VueCookies.get('shop_token')
        }
      }).then(res => {
        if(res.data.status === 'success'){
          next()
        }else if(res.data.status === 'error'){
          next('/')
        }
      })
    },
    children: [{
        path: '/index',
        component: () => import('../views/shopIndex/shopIndex.vue')
      },
      {
        path: '/changePass',
        component: () => import('../views/shopIndex/changePass.vue')
      },
      {
        path: '/shopUi',
        component: () => import('../views/shopIndex/shopUi.vue')
      },
      {
        path: '/editUserInfo',
        component: () => import('../views/shopIndex/editUserInfo.vue')
      },
      {
        path: '/orderList',
        component: () => import('../views/order/orderList.vue')
      },
      {
        path: '/orderReturn',
        component: () => import('../views/order/orderReturn.vue')
      },
      {
        path: '/orderReturnDetail/:id',
        component: () => import('../views/order/orderReturnDetail.vue')
      },
      {
        path: '/orderReturn2',
        component: () => import('../views/order/orderReturn2.vue')
      },
      {
        path: '/orderReturnDetail2/:id',
        component: () => import('../views/order/orderReturnDetail2.vue')
      },
      {
        path: '/orderInfo/:id',
        component: () => import('../views/order/orderInfo.vue')
      },

      {
        path: 'addgoods',
        component: () => import('../views/goods/addGoods.vue')
      },
      {
        path: 'addgoodss',
        name: 'shop.addgoodss',
        component: () => import('../views/goods/addGoodss.vue')
      },
      {
        path: 'addmart',
        component: () => import('../views/goods/martAdd.vue')
      },
      {
        path: 'goodslist',
        component: () => import('../views/goods/goodsList.vue')
      },
      {
        path: 'setgoods',
        component: () => import('../views/goods/setGoods.vue')
      },
      {
        path: '/sitemain',
        component: () => import('../views/site/siteMain.vue')
      },
      {
        path: '/paymentday',
        component: () => import('../views/site/paymentDay.vue')
      },
      {
        path: '/service',
        component: () => import('../views/site/service.vue')
      },
      {
        path: 'setClass',
        component: () => import('../views/goods/setClass.vue')
      },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router